export default __webpack_public_path__ + "static/media/possession.1a7387c0.png";